import { useState } from 'react';
import { Plus, Download, Loader2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { exportJobsToExcel } from '../../../utils/exportJobs';

export default function JobsHeader({ jobs = [], canCreateJob = true }) {
    const [isExporting, setIsExporting] = useState(false);

    const handleExport = () => {
        if (!jobs || jobs.length === 0) {
            return;
        }
        
        setIsExporting(true);
                setTimeout(() => {
            try {
                exportJobsToExcel(jobs);
            } catch (error) {
                console.error('Export failed:', error);
            } finally {
                setIsExporting(false);
            }
        }, 100);
    };

    return (
        <div className="bg-white border-b border-gray-200 px-4 py-3">
            <div className="flex items-center justify-between mb-3">
                <h1 className="text-xl font-bold text-gray-900">Jobs</h1>

                <div className="flex items-center gap-2">
                    <button
                        onClick={handleExport}
                        disabled={isExporting}
                        className="px-3 py-2 border border-gray-300 rounded-lg text-xs font-medium flex items-center gap-1.5 bg-white shadow-sm hover:bg-gray-50 disabled:opacity-70 transition"
                    >
                        {isExporting ? (
                            <>
                                <Loader2 className="w-4 h-4 animate-spin text-gray-600" />
                                Exporting...
                            </>
                        ) : (
                            <>
                                <Download className="w-4 h-4 text-gray-600" />
                                Export to Excel
                            </>
                        )}
                    </button>

                    {canCreateJob && (
                        <Link
                            to="/profile/create/jobs"
                            className="px-3 py-2 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-lg text-xs font-bold flex items-center gap-1.5 shadow-md hover:shadow-lg transition-shadow"
                        >
                            <Plus className="w-4 h-4" /> New Job
                        </Link>
                    )}
                </div>
            </div>
        </div>
    );
}